// The cart page: the stepper, remove and the note change the cart through Shopify's cart API and
// swap this section in place (the API renders it back). Without script the form posts to /cart.
(function () {
  'use strict';

  const first = document.querySelector('[data-cart]');
  if (!first) return;

  const SHOP = window.SBG_SHOP || {};
  const CART_URL = SHOP.cart || '/cart';
  const CHANGE = `${CART_URL}/change.js`;
  const UPDATE = `${CART_URL}/update.js`;
  const TOAST_MS = 3200;
  const sectionId = first.getAttribute('data-section-id');
  const live = () => document.querySelector('[data-cart]');
  let busy = false;
  let toastTimer = 0;

  function say(message) {
    const toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.setAttribute('data-show', '');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.removeAttribute('data-show'), TOAST_MS);
  }
  function writeBag(count) {
    const badge = document.getElementById('bag-count');
    const link = document.getElementById('bag-link');
    if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
    if (link) link.setAttribute('aria-label', count === 0 ? 'Bag, empty' : `Bag, ${count} ${count === 1 ? 'item' : 'items'}`);
  }
  // The gift app drops its bar into the form as a first child, which would take the lines' column.
  // Anything that is not ours moves into the summary room, and rides along when the section is swapped.
  const OURS = '.cart__lines, .cart__sum';
  function tuck(root) {
    const form = root.querySelector('[data-cart-form]');
    const sum = root.querySelector('.sum');
    if (!form || !sum) return;
    [...form.children].filter((child) => !child.matches(OURS)).forEach((widget) => {
      const after = sum.querySelector('.sum__ship');
      if (after) after.insertAdjacentElement('afterend', widget); else sum.prepend(widget);
      widget.classList.add('sum__app');
    });
  }
  // The shipping protection app (Captain) puts its fee in the bag when she presses Check out and takes it
  // out again when she comes back, so the subtotal here never shows it. While its switch is on, the
  // summary lists it under the subtotal, in the app's own words and at its own price. The switch reports
  // its state in aria-checked. A row is only written when it changes, so the page watch cannot loop.
  const PROTECTION = '#tm_switch_btn';
  function showProtection() {
    const root = live();
    const rows = root && root.querySelector('.sum__rows');
    if (!rows) return;
    const toggle = document.querySelector(PROTECTION);
    const priceEl = document.querySelector('.ship-insurance .tm_price');
    const titleEl = document.querySelector('.ship-insurance .tm_title');
    const price = priceEl ? priceEl.textContent.replace(/[()]/g, '').trim().replace(/\.00$/, '') : '';
    const title = (titleEl && titleEl.textContent.trim()) || 'Shipping protection';
    const on = Boolean(toggle) && toggle.getAttribute('aria-checked') === 'true' && price !== '';
    const row = rows.querySelector('[data-protection]');
    if (!on) {
      if (row) row.remove();
      return;
    }
    if (row) {
      const [dt, dd] = [row.querySelector('dt'), row.querySelector('dd')];
      if (dt.textContent !== title) dt.textContent = title;
      if (dd.textContent !== price) dd.textContent = price;
      return;
    }
    const fresh = document.createElement('div');
    fresh.setAttribute('data-protection', '');
    fresh.append(Object.assign(document.createElement('dt'), { textContent: title }), Object.assign(document.createElement('dd'), { textContent: price }));
    rows.append(fresh);
  }
  let watchedToggle = null;
  const toggleWatch = new MutationObserver(showProtection);
  function watchProtection() {
    const toggle = document.querySelector(PROTECTION);
    if (toggle && toggle !== watchedToggle) {
      toggleWatch.disconnect();
      toggleWatch.observe(toggle, { attributes: true, attributeFilter: ['aria-checked'] });
      watchedToggle = toggle;
    }
    showProtection();
  }

  const watch = new MutationObserver(() => { const root = live(); if (root) tuck(root); watchProtection(); });
  watch.observe(document.body, { childList: true, subtree: true });
  tuck(first);
  watchProtection();
  // The API hands back this section rendered for the new cart; only its inside is swapped.
  function swap(html) {
    const root = live();
    if (!root || !html) { location.reload(); return; }
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
    if (!fresh) { location.reload(); return; }
    const widgets = [...root.querySelectorAll('.sum > .sum__app')];
    root.replaceWith(fresh);
    const sum = fresh.querySelector('.sum');
    const after = sum && sum.querySelector('.sum__ship');
    widgets.forEach((widget) => { if (after) after.insertAdjacentElement('afterend', widget); else if (sum) sum.prepend(widget); });
  }
  async function post(url, body) {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: sectionId }) });
    const cart = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(cart.description || cart.message || 'Could not update your bag.');
    return cart;
  }
  async function change(line, quantity, focusLine) {
    if (busy) return;
    busy = true;
    live().setAttribute('aria-busy', 'true');
    try {
      const cart = await post(CHANGE, { line, quantity });
      swap(cart.sections && cart.sections[sectionId]);
      writeBag(Number(cart.item_count) || 0);
      if (focusLine) {
        const target = live().querySelector(`[data-line="${focusLine}"] [data-qty]`) || live().querySelector('h1');
        if (target) target.focus({ preventScroll: true });
      }
    } catch (err) {
      say(err.message);
      const root = live();
      if (root) root.removeAttribute('aria-busy');
    } finally {
      busy = false;
    }
  }

  document.addEventListener('click', (e) => {
    const root = live();
    if (!root || !root.contains(e.target)) return;
    const step = e.target.closest('[data-step]');
    if (step) {
      const line = step.closest('[data-line]');
      const input = line.querySelector('[data-qty]');
      const next = Math.max(0, (Number(input.value) || 0) + Number(step.getAttribute('data-step')));
      change(Number(line.getAttribute('data-line')), next, line.getAttribute('data-line'));
      return;
    }
    const remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      const line = remove.closest('[data-line]');
      change(Number(line.getAttribute('data-line')), 0);
    }
  });
  document.addEventListener('change', (e) => {
    const root = live();
    if (!root || !root.contains(e.target)) return;
    if (e.target.matches('[data-qty]')) {
      const line = e.target.closest('[data-line]');
      change(Number(line.getAttribute('data-line')), Math.max(0, Number(e.target.value) || 0), line.getAttribute('data-line'));
    }
    if (e.target.matches('[data-note]')) {
      fetch(UPDATE, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: e.target.value }) })
        .then((res) => { if (!res.ok) say('Could not save your note.'); })
        .catch(() => say('Could not save your note.'));
    }
  });
  // Quick add elsewhere on the page (the add-on) changes the cart too: draw the new bag.
  document.addEventListener('sbg:cart:added', async () => {
    try {
      const cart = await post(UPDATE, {});
      swap(cart.sections && cart.sections[sectionId]);
    } catch (err) {
      location.reload();
    }
  });
})();